// extracted by mini-css-extract-plugin
export var locationCard = "_gc-0";